//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
let d=[[[1,"EndAngleExpression",0,"Expression",0],[0,"ParentDuct",1,"Routing.Stock",0],[0,"ReverseWindDirection",1,0],[0,"TrimToParentDuct",1,0],[0,"Type",1,0],[0,"WindCatcherDuct",1,"Routing.Stock",0]],[[[],"GetClosestParentDuctSegment",{R_:{segment:"Routing.LineSegment"}},0,0]],[]];
SPLM.Routing.WindCatcherBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.WindCatcherBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.WindCatcherBuilder.WindCatcherType = Object.freeze({
    "Arc" : "Arc", "Triangle" : "Triangle"});

export default SPLM;